var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBluePadlock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 13,
    fill: "#D9E5F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2927_44784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.375 10.375H15.625V9.0625C15.625 8.36631 15.3484 7.69863 14.8562 7.20634C14.3639 6.71406 13.6962 6.4375 13 6.4375C12.3038 6.4375 11.6361 6.71406 11.1438 7.20634C10.6516 7.69863 10.375 8.36631 10.375 9.0625V10.375H8.625C8.39294 10.375 8.17038 10.4672 8.00628 10.6313C7.84219 10.7954 7.75 11.0179 7.75 11.25V17.375C7.75 17.6071 7.84219 17.8296 8.00628 17.9937C8.17038 18.1578 8.39294 18.25 8.625 18.25H17.375C17.6071 18.25 17.8296 18.1578 17.9937 17.9937C18.1578 17.8296 18.25 17.6071 18.25 17.375V11.25C18.25 11.0179 18.1578 10.7954 17.9937 10.6313C17.8296 10.4672 17.6071 10.375 17.375 10.375ZM13 14.9688C12.8702 14.9688 12.7433 14.9303 12.6354 14.8582C12.5275 14.786 12.4434 14.6835 12.3937 14.5636C12.344 14.4437 12.331 14.3118 12.3564 14.1845C12.3817 14.0572 12.4442 13.9402 12.536 13.8485C12.6277 13.7567 12.7447 13.6942 12.872 13.6689C12.9993 13.6435 13.1312 13.6565 13.2511 13.7062C13.371 13.7559 13.4735 13.84 13.5457 13.9479C13.6178 14.0558 13.6562 14.1827 13.6562 14.3125C13.6562 14.4865 13.5871 14.6535 13.464 14.7765C13.341 14.8996 13.174 14.9688 13 14.9688ZM14.75 10.375H11.25V9.0625C11.25 8.59837 11.4344 8.15325 11.7626 7.82506C12.0908 7.49687 12.5359 7.3125 13 7.3125C13.4641 7.3125 13.9092 7.49687 14.2374 7.82506C14.5656 8.15325 14.75 8.59837 14.75 9.0625V10.375Z",
    fill: "#0B1C56"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2927_44784"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluePadlock);
export default __webpack_public_path__ + "static/media/blue-padlock.bf56cd43c2f89b104e87ac004b211255.svg";
export { ForwardRef as ReactComponent };